var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBusDoubleDecker = function SvgBusDoubleDecker(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14 7c0 3.87-3.13 7-7 7s-7-3.13-7-7 3.13-7 7-7 7 3.13 7 7m-9.75 4v-.75H6.5c.41 0 .75-.34.75-.75V7.25H9.5c.41 0 .75-.34.75-.75V4.25H11c.41 0 .75-.34.75-.75s-.34-.75-.75-.75H9.5c-.41 0-.75.34-.75.75v2.25H6.5c-.41 0-.75.34-.75.75v2.25H3.5c-.41 0-.75.34-.75.75V11c0 .41.34.75.75.75s.75-.34.75-.75"
  })));
};
export default SvgBusDoubleDecker;